import CheckBox from '../../../../UtilComponent/level_1/CheckBox'

const IsFavorite = (props: any) => {
  const { isFavorites, setIsFavorites } = props
  const label = 'お気に入りのみ'
  const id = 'favorite'

  return (
    <CheckBox
      state={isFavorites}
      setState={setIsFavorites}
      label={label}
      id={id}
    />
  )
}

export default IsFavorite
